<div class="">
    <p class="title">{{ SegmentDepartureDate(flight.departureDate) }}</p>
    <small *ngIf="flight.arrivalDate !== flight.departureDate">{{ 'LAYOUT_ONE.landing' | translate }} {{ SegmentDepartureDate(flight.arrivalDate)}}</small>
</div>